import React, { useEffect } from "react";
import {
  Body,
  Display,
  GutterContainer,
  LinkText,
  TemplateFullGutter,
  Keyline,
  CmsSpacer
} from "@common/AggregationComponent";
import { useLocation } from "react-router-dom";
import {
  checkPreviousPageExists,
  getBrandForMeta,
  transformBrandForGoogleAnalytics
} from "@util/common";
import { Helmet } from "react-helmet-async";
import type { CombinedReducersType } from "@type/index";
import { sendTrackPageView } from "@util/gtm";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IS_ENV } from "@util/config";

const ServerError = (): any => {
  const { t } = useTranslation();
  const location = useLocation();
  const config = useSelector((store: CombinedReducersType) => store.app);
  const BASE_PATH_NAME = `/${config.region}/${config.language}`;

  useEffect(() => {
    const isFinalTitle = document.title === t("text_503_error_title");
    const isNotDefaultTitle = document.title !== "text_503_error_title";
    if (window.dataLayer && isFinalTitle && isNotDefaultTitle) {
      sendTrackPageView({
        event: "trackPageView",
        brand: transformBrandForGoogleAnalytics(config.brand_name), // UQの場合"uq"
        pageType: "imagesearch", // TPUの場合TPU
        subID: "", // subid取得できる場合subidを出力、できない場合undefined
        pageUrlPath: `${location.pathname}${location.search}`, // path+param
        pageTitle: t("text_503_error_title"), // title
        previousPageExists: checkPreviousPageExists() // 前のページがある場合true、ない場合false
      });
    }
  }, [document.title, t, location]);
  return (
    <>
      <Helmet
        titleTemplate={t("text_503_error_title")}
        defaultTitle={t("text_503_error_title")}
        htmlAttributes={{ lang: config.language }}
      >
        <meta name="description" content={t("text_503_error_description")} />
        <meta property="og:site_name" content={getBrandForMeta()} />
        <meta property="og:title" content={t("text_503_error_title")} />
        <meta property="og:description" content={""} />
        <meta property="og:image" content={""} />
        <meta property="fb:app_id" content={""} />
        <meta name="twitter:card" content={"summary"} />
        <meta name="twitter:site" content={getBrandForMeta()} />
        <meta name="twitter:title" content={t("text_503_error_title")} />
        <meta name="twitter:image" content={""} />
        <meta
          property="og:url"
          content={`${window.origin}${BASE_PATH_NAME}/image-search`}
        />
      </Helmet>
      <TemplateFullGutter
        mainContent={
          <GutterContainer>
            <div className="fr-ec-mb-spacing-05" />
            <Display
              lang={config.language}
              element="h1"
              variant="display2"
              className="fr-ec-mb-spacing-04"
            >
              {t("text_503_error_title")}
            </Display>
            <Keyline className="fr-ec-mb-spacing-05" />
            <Body element="p" variant="standard">
              {t("text_503_error_description-1")}
            </Body>
            <CmsSpacer spaces="xs" />
            <Body element="p" variant="standard">
              {t("text_503_error_description-2")}
            </Body>
            <CmsSpacer spaces="xs" />
            <Body
              element="p"
              variant="standard"
              className="fr-ec-mb-spacing-06"
            >
              {t("text_503_error_instruction", {
                text_contactus: t("text_contactus")
              })}
            </Body>
            <Body
              element="p"
              variant="standard"
              className="fr-ec-mb-spacing-02"
            >
              <LinkText
                ariaLabel="aria Label"
                element="a"
                href={`${BASE_PATH_NAME}/`}
                variant="standalone-secondary"
                className="fr-ec-mb-spacing-02"
              >
                {t("text_image_search_go_to_top")}
              </LinkText>
            </Body>
            <Body element="p" variant="standard">
              <LinkText
                element="a"
                href={IS_ENV(config.region, config.brand_name).faqUrl}
                variant="standalone-secondary"
              >
                {t("text_contactus")}
              </LinkText>
            </Body>
          </GutterContainer>
        }
      />
    </>
  );
};

export default ServerError;
